import './storageIcon.css';

export default function StorageIcon() {
    return (
        <div className="storage-icon">
            <svg width="122.629" height="98.103" viewBox="0 0 122.629 98.103">
                <path id="Icon_material-round-storage" data-name="Icon material-round-storage" d="M15.263,104.1h98.1a12.263,12.263,0,1,0,0-24.526h-98.1a12.263,12.263,0,1,0,0,24.526Zm0-18.394H27.526V97.972H15.263ZM3,18.263A12.3,12.3,0,0,0,15.263,30.526h98.1a12.263,12.263,0,1,0,0-24.526h-98.1A12.3,12.3,0,0,0,3,18.263Zm24.526,6.131H15.263V12.131H27.526ZM15.263,67.314h98.1a12.263,12.263,0,1,0,0-24.526h-98.1a12.263,12.263,0,1,0,0,24.526Zm0-18.394H27.526V61.183H15.263Z" transform="translate(-3 -6)" fill="#88cdf6"/>
            </svg>
        </div>
    )
}